import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Tag, TrendingUp, Award } from 'lucide-react';

export function MerchantStatsCards({ stats, user, navigate }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6 mb-8">
      <Card data-testid="total-coupons-card" className="hero-card">
        <CardHeader><CardTitle className="flex items-center gap-2"><Tag className="h-5 w-5" /> Total de Cupons</CardTitle></CardHeader>
        <CardContent>
          <p className="text-3xl font-bold">{stats?.total_coupons || 0}</p>
          <p className="text-sm text-slate-300 mt-1">Cupons criados</p>
        </CardContent>
      </Card>
      <Card data-testid="total-claims-card" className="hero-card">
        <CardHeader><CardTitle className="flex items-center gap-2"><TrendingUp className="h-5 w-5" /> Total de Resgates</CardTitle></CardHeader>
        <CardContent>
          <p className="text-3xl font-bold">{stats?.total_claims || 0}</p>
          <p className="text-sm text-slate-300 mt-1">Cupons resgatados</p>
        </CardContent>
      </Card>
      <Card data-testid="plan-card" className="hero-card">
        <CardHeader><CardTitle className="flex items-center gap-2"><Award className="h-5 w-5" /> Sua Assinatura</CardTitle></CardHeader>
        <CardContent>
          <p className="text-xl font-bold capitalize">{user?.plan || 'gratuito'}</p>
          <p className="text-sm text-slate-300 mt-1">
            {user?.plan === 'black' ? 'Cupons ilimitados' :
             user?.plan === 'platinum' ? '50 cupons/mês' :
             user?.plan === 'premium' ? '30 cupons/mês' : '10 cupons/mês'}
          </p>
          <p className="text-xs text-slate-400 mt-1">Cobranca mensal recorrente</p>
          <Button size="sm" className="mt-3 bg-white/20 hover:bg-white/30 text-white text-xs border border-white/30"
            onClick={() => navigate('/edit-profile')} data-testid="manage-plan-btn">
            Gerenciar Plano
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
